import env from '@beam-australia/react-env';

import { ENV_CONFIG_ATTRIBUTES } from 'src/config/env-config-attributes';

export const config = {
  ENV: env(ENV_CONFIG_ATTRIBUTES.ENV),
  LANGUAGE: env(ENV_CONFIG_ATTRIBUTES.LANGUAGE),
  AUTH_THEME: env(ENV_CONFIG_ATTRIBUTES.AUTH_THEME),
  AUTH_CLIENT_ID: env(ENV_CONFIG_ATTRIBUTES.AUTH_CLIENT_ID),
  AUTH_SCOPES: env(ENV_CONFIG_ATTRIBUTES.AUTH_SCOPES),
  AUTH_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_URL),
  AUTH_BASE_URL: env(ENV_CONFIG_ATTRIBUTES.AUTH_BASE_URL),
  DELIVERY_FAQ_LINK: env(ENV_CONFIG_ATTRIBUTES.DELIVERY_FAQ_LINK),
  TERMSLINK: env(ENV_CONFIG_ATTRIBUTES.TERMSLINK),
  GET_STARTED: env(ENV_CONFIG_ATTRIBUTES.GET_STARTED),
  CUSTOMER_SERVICE: env(ENV_CONFIG_ATTRIBUTES.CUSTOMER_SERVICE),
  MINE_SIDER: env(ENV_CONFIG_ATTRIBUTES.MINE_SIDER),
  MAIN_PAGE: env(ENV_CONFIG_ATTRIBUTES.MAIN_PAGE),
};
